import React, { useState, useEffect, Fragment } from "react";

import { observer } from "mobx-react-lite";

import "./Layout.css";
import { makeStyles } from "@mui/styles";

//import { IGeneralSystemSetting } from "../../../common/interfaces/IGeneralSystemSetting";
import { useStores } from "../../../core/stores/index";
import { Navigation } from "Navigation";
import { useMsalAuthentication } from "@azure/msal-react";
import { InteractionType, PublicClientApplication } from "@azure/msal-browser";
import { SiteSessionService } from "core/services/SiteSessionService";
import { AuthGuard } from "AuthGuard";

interface LayoutProp {
    children: JSX.Element;
    msalInstance: PublicClientApplication;
}

export const Layout = observer((props: LayoutProp) => {    

    const environmentName = "DEV";

    return (
        <>
        <AuthGuard msalInstance={props.msalInstance}>
            <div className="container-fluid g-0">
                <div className="row pinkBanner ps-4 align-items-center">
                    <div className="col-10 appNameEnv text-left align-text-center banner"></div>
                </div>
                <div className="row  justify-content-left g-0">
                    <div className="col col-lg-2 justtify-content-left g-0">
                        <div className="row sidebar g-0 navigationRow">
                            <div className="col">
                                <Navigation />
                            </div>
                        </div>
                    </div>
                    <div className="col-10">
                        <Fragment>{props.children}</Fragment>
                    </div>
                </div>
            </div>
            </AuthGuard>
        </>
    );
});
